export default "<div class=\"loader-body\" *ngIf=\"loading\">\r\n  <div class=\"loading\">Loading</div>\r\n</div>\r\n<router-outlet></router-outlet>\r\n"